<mat-card>
    <app-search-bar (searchChange)="onSearchChange($event)"></app-search-bar>
    <div class="unconfirmedUserHeader">
        <div>Nutzer</div>
        <div>Vorname</div>
        <div>Nachname</div>
        <div></div>
        <div></div>
    </div>
    <div *ngFor="let unconfirmedUser of unconfirmedUserSlice; let i = index" class="unconfirmedUserRow">
        <div>{{ unconfirmedUser.userName }}</div>
        <div>
            {{ unconfirmedUser.firstName ? unconfirmedUser.firstName : '-' }}
        </div>
        <div>
            {{ unconfirmedUser.lastName ? unconfirmedUser.lastName : '-' }}
        </div>
        <button matButton="elevated" class="green-confirm" (click)="onConfirmUser(unconfirmedUser.userId)">
            Nutzer bestätigen
        </button>
        <button matButton="elevated" color="warn" (click)="onDeleteUser(unconfirmedUser.userId)">
            Nutzer löschen
        </button>
    </div>
    <mat-paginator [length]="totalNumberOfElements" [pageSize]="this.pageSize" [pageIndex]="this.pageIndex"
        [pageSizeOptions]="[5, 10, 15]" (page)="onPageChange($event)"></mat-paginator>
</mat-card>